import classes from "./ReleaseActivityPage.module.css";
import Skeleton from "react-loading-skeleton";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {
    POLL_SHARE_MODE,
    POLL_TYPE,
    RELEASE_ACTIVITY_VIEW, RELEASE_ATTENDANCE,
    RELEASE_POLL_TEXT,
    SYNC_LMS_OPTIONS
} from "../../utils/constants";
import { removePrefix} from "../../utils/helpers";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import ViewOneMoreStep from "./ViewOneMoreStep";
import ViewInvalidActivity from "./ViewInvalidActivity";
import ViewRelease from "./ViewRelease";


export default function ReleaseActivityPage({setPageIdentifier}) {
    const { getPublishedPollDataFromKey, } = PollApiCalls();
    const { pollKey, pollCode } = useParams();
    const [, getSession] = useLocalStorageNew("session", {});

    const [dataLoading, setDataLoading] = useState(true);
    const [invalidPoll, setInvalidPoll] = useState(false);
    const [pollData, setPollData] = useState({});
    const [pageView, setPageView] = useState(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
    const [resetCount, setResetCount] = useState(0);





    const loadPublishedData = (redirectView) => {
        setResetCount(resetCount + 1);
        getPublishedPollDataFromKey(pollKey, pollCode).then((res) => {
            const {poll, questions} = res;


            res.questions = res.questions.sort((a, b) => a.serialNo - b.serialNo);

            setPollData(JSON.parse(JSON.stringify(res)));
            setPageIdentifier(poll.pollType === POLL_TYPE.ATTENDANCE ? RELEASE_ATTENDANCE : RELEASE_POLL_TEXT);

            if (!poll || ! questions || poll.active === "2") {
                setPageView(RELEASE_ACTIVITY_VIEW.INVALID_ACTIVITY_VIEW);
                return;
            }

            if (poll.isValid === false) {
                setPageView(RELEASE_ACTIVITY_VIEW.INVALID_ACTIVITY_VIEW);
                return;
            }


            const {pollType, lmsHomeUrl, syncLmsOption} = poll;

            if (pollType !== POLL_TYPE.MERGED_POLL && pollType !== POLL_TYPE.ATTENDANCE) {
                setPageView(RELEASE_ACTIVITY_VIEW.INVALID_ACTIVITY_VIEW);
                return;
            }


            if (removePrefix(poll.index1Pk) !== getSession().userId) {
                setPageView(RELEASE_ACTIVITY_VIEW.INVALID_ACTIVITY_VIEW);
                return;
            }

            if (syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED && !lmsHomeUrl) {
                setPageView(RELEASE_ACTIVITY_VIEW.ONE_MORE_STEP_VIEW);
            } else {
                if (!!redirectView) {
                    let isShareEach = poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH && poll.pollType !== POLL_TYPE.ATTENDANCE;
                    if (redirectView === RELEASE_ACTIVITY_VIEW.METRIC_VIEW && !isShareEach) {
                        let sharedQuestions = questions.filter(q => !!q.shareCount);
                        if (sharedQuestions.length === 0) {
                            setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
                        } else {
                            setPageView(RELEASE_ACTIVITY_VIEW.METRIC_VIEW);
                        }
                    } else {
                        setPageView(redirectView);
                    }
                } else {
                    setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
                }
            }

        }).catch(e => {
            console.log(e);
            setInvalidPoll(true);
        }).finally(() => {
            setDataLoading(false);
        });
    }





    const resetPollData = (redirectView) => {
        loadPublishedData(redirectView);
    };

    const reloadPollData = () => {
        setDataLoading(true);
        loadPublishedData();
    };


    useEffect(() => {
        setDataLoading(true);
        loadPublishedData();
    }, []);


    if (dataLoading) {
        const skeletonLoaderStyle = {width: "100%", flex: 1, minHeight: 0, maxHeight: 70};

        return (
            <div className={classes.parentContainer}>
                <div className={classes.mainCard}>
                    <span style={{...skeletonLoaderStyle, maxHeight: 40}}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>

                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                    <span style={skeletonLoaderStyle}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>

                </div>
            </div>
        );
    }


    if (pageView === RELEASE_ACTIVITY_VIEW.INVALID_ACTIVITY_VIEW) {
        return <ViewInvalidActivity pollData={pollData}/>;
    }

    if (pageView === RELEASE_ACTIVITY_VIEW.ONE_MORE_STEP_VIEW) {
        return <ViewOneMoreStep pollData={pollData}/>;
    }


    return (
        <ViewRelease
            pollData={pollData}
            setPollData={setPollData}
            pageView={pageView}
            setPageView={setPageView}
            resetData={resetCount}
            resetPollData={resetPollData}
            reloadPollData={reloadPollData}
        />
    );
}